<template lang="pug">
    div.col-md-4
        div.box
            div.box-header.dker.b-b
                h3 Top Purchased by Tag
                small Sales percentage of tags
            div.box-tool
                export-chart(chart="tags")

            div.box-body
                chart(:options="options", ref="chart")
</template>

<script>
import { mapGetters } from 'vuex';
import mixins from './mixins';

export default {
    mixins: [mixins],

    computed: {
        ...mapGetters('reportProduct', ['chartTagsSeriesData']),

        options() {
            return {
                title: {
                    show: false,
                },
                grid: {
                    top: 1,
                    bottom: 1,
                    right: 1,
                    left: 1,
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} <br/>{d}%',
                },
                series: [
                    {
                        name: 'Top Tags Chart',
                        type: 'pie',
                        radius: '70%',
                        center: ['50%', '50%'],
                        data: this.chartTagsSeriesData,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                    },
                ],
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.echarts {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/top-purchased-by-tags.vue